/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientFamilyHistories = sqliteTable('patient_family_histories', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  history_status: text('history_status'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  updated_by: text('updated_by'),
});
